import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getWebBuilderDetails, updatePageSettings } from '../api'

export const usePageBlueprint = (uniqueUrl) => {
  return useQuery({
    queryKey: ['pageBlueprint', uniqueUrl],
    queryFn: async () => {
      const response = await getWebBuilderDetails(uniqueUrl, 'home', 'builder')
      const blueprint = response?.blueprint || response?.data?.blueprint || {}
      const siteName = response?.name || response?.data?.name || ''
      const active = response?.active || {}
      const subdomain = response?.subdomain || ''
      const domain = response?.domain || {}
      const integrations = response?.integrations || response?.data?.integrations || {}
      const subdomainUpdatedAt = response?.subdomainUpdatedAt || response?.data?.subdomainUpdatedAt
      const staticMedia = response?.staticMedia || response?.data?.staticMedia || []
      const aiCompanionMode = response?.aiCompanionMode ?? response?.data?.aiCompanionMode ?? false
      return { blueprint, siteName, active, subdomain, domain, integrations, subdomainUpdatedAt, staticMedia, aiCompanionMode }
    },
    enabled: !!uniqueUrl,
    staleTime: 5 * 60 * 1000,
  })
}

export const useUpdatePageSettings = () => {
  const queryClient = useQueryClient()
  
  return useMutation({
    mutationFn: async ({ uniqueUrl, blueprint, pageName, pageUrlDirty }) => {
      return await updatePageSettings(uniqueUrl, blueprint, pageName, { pageUrlDirty })
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['pageBlueprint', variables.uniqueUrl] })
      queryClient.invalidateQueries({ queryKey: ['pages', variables.uniqueUrl] })
      
      if (variables.pageUrlDirty) {
        window.location.hash = 'home'
        window.location.reload()
      }
    },
  })
}

